module.exports = __webpack_public_path__ + "img/rotate-left.85799bc3.png";